import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/Auth';
import { nextChallengeViewModel } from '../views/next_challenge/next.challenge.viewmodel';
import { ADD_MORE_BRANCHES, NEXT_CHALLENGE_ROUTE } from '../../constants/routes.constants';
import GuestRedirectVerification from './GuestRedirectVerification';
import SignupStep1 from '../views/onboarding/signup_popups/SignupStep1';

const SideBarBranch = ({ brancheList, onBranchClick, setShowModal }) => {
  const history = useHistory();
  const { dependent, guardian, school, fetchAPI } = useAuth();
  const [branches, setBranches] = useState(brancheList ? brancheList : []);
  // const [showModal, setShowModal] = useState(false);

  const getBranchList = () => {
    fetchAPI(nextChallengeViewModel.getBranch)
      .then((res) => {
        setBranches(res);
      })
      .catch((err) => { });
  };

  const addMoreBranch = () => {
    if (dependent && !guardian) {
      history.push({
        pathname: ADD_MORE_BRANCHES,
        state: {
          from: 'dashboard',
          dependent: dependent,
          branches: branches
        },
      })
    }
    else {
      if (!school && !dependent) {
        setShowModal(true);
      }
    }
  }

  useEffect(() => {
    if (dependent && !guardian) {
      if (!brancheList) {
        getBranchList();
      }
    }
  }, []);

  const handleClick = (tag) => {
    if (history.location.pathname !== NEXT_CHALLENGE_ROUTE) {
      history.push({
        pathname: NEXT_CHALLENGE_ROUTE,
        state: {
          tag: tag,
          filter: 'tag'
        }
      })
      localStorage.setItem("tagsFilter",JSON.stringify({tag:tag,filter:'tag'}))
    } else {
      onBranchClick(tag)
    }
  }

  return (
    <>
      <div className='accordian-body'>
        <ul>{branches.map((tag, index) => (
          <li key={index} onClick={(e) => handleClick(tag.tag)}><a href='#' id={tag.id}>#{tag.tag}</a></li>
          // <li key={index}><a href='#' id={tag.id}>#{tag.tag}</a></li>
        ))}
        </ul>
      </div>

      <div className='accordian-footer'
        onClick={addMoreBranch}>
        <span className='plus-ic'>+</span>
        <span className='hide-on-toggle hover-underline'>Add more Branches to your TaleTree</span>
      </div>

      {/* <GuestRedirectVerification showModal={showModal} setShowModal={setShowModal} /> */}
      {/* <SignupStep1 showModal={showModal} setShowModal={setShowModal} /> */}
    </>
  );
}

export default SideBarBranch;
